import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormTownHall } from 'system/pages/town-halls/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersTownHallProps {
  filterTownHallForm: FormikProps<FiltersFormTownHall>;
}

const FiltersTownHall = ({ filterTownHallForm }: FiltersTownHallProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-townhalls-content"
        id="panel-townhalls-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterTownHallForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice zona"
                label="Zona"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterTownHallForm.values.code}
                onChange={filterTownHallForm.handleChange}
                error={filterTownHallForm.touched.code && Boolean(filterTownHallForm.errors.code)}
                helperText={filterTownHallForm.errors.code}
                inputProps={{
                  maxLength: '2',
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione zona"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterTownHallForm.values.description}
                onChange={filterTownHallForm.handleChange}
                error={
                  filterTownHallForm.touched.description &&
                  Boolean(filterTownHallForm.errors.description)
                }
                helperText={filterTownHallForm.errors.description}
                inputProps={{
                  maxLength: '20',
                }}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterTownHallForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersTownHall.displayName = 'Filters TownHall component';

export default FiltersTownHall;
